import {
  EVENT_ACTION_CHECKED,
  EVENT_ACTION_UNCHECKED,
  EVENT_CHECKBOX_INTERACTION,
  EVENT_PROPERTY_ACTION,
  EVENT_PROPERTY_DESCRIPTOR,
  EVENT_PROPERTY_UI_CONTEXT,
} from '../../utils/analytics/events'
import { useAnalytics } from '../components/Analytics'
import { CheckboxProps } from '../components/Checkbox/Checkbox'

export const useCheckboxProps = (props: CheckboxProps) => {
  const { analytics } = useAnalytics()
  const { tracking, onChange, ...restCheckboxProps } = props

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    analytics?.track(EVENT_CHECKBOX_INTERACTION, {
      [EVENT_PROPERTY_ACTION]: e.target.checked
        ? EVENT_ACTION_CHECKED
        : EVENT_ACTION_UNCHECKED,
      [EVENT_PROPERTY_DESCRIPTOR]: tracking?.descriptor,
      [EVENT_PROPERTY_UI_CONTEXT]: tracking?.ui_context,
    })

    if (onChange) {
      onChange(e)
    }
  }

  return {
    onChange: handleChange,
    ...restCheckboxProps,
  }
}
